<app-modal (dismissed)="onCloseClick()" width="min(1180px, calc(100vw - 40px))">
    <div class="car-dialog">
        <header class="dialog-header">
            <div>
                <span class="eyebrow">{{ 'Car Details' | translate }}</span>
                <h2 *ngIf="carDetails != undefined">{{ carDetails.CarId }}</h2>
            </div>
            <button (click)="onCloseClick()" [attr.aria-label]="'Close car details' | translate"
                    [title]="'Close' | translate" class="icon-button"
                    type="button">
                <i class="material-icons">close</i>
            </button>
        </header>

        <div *ngIf="carDetails != undefined" class="dialog-body">
            <section class="detail-grid">
                <div class="detail-panel">
                    <h3>{{ 'Vehicle' | translate }}</h3>
                    <dl>
                        <div>
                            <dt>{{ 'Car Number' | translate }}</dt>
                            <dd>{{ carDetails.CarNumber }}</dd>
                        </div>
                        <div>
                            <dt>{{ 'Car Model' | translate }}</dt>
                            <dd>{{ carDetails.CarModel }}</dd>
                        </div>
                        <div *ngIf="carDetails.CarDetails != undefined">
                            <dt>{{ 'Authorization' | translate }}</dt>
                            <dd>{{ carDetails.CarDetails.Authorization }}</dd>
                        </div>
                        <div>
                            <dt>{{ 'Last Login' | translate }}</dt>
                            <dd>{{ (carDetails.LastLoginAsString || 'never') | translate }}</dd>
                        </div>
                    </dl>
                </div>

                <div class="detail-panel actions-panel">
                    <h3>{{ 'Services' | translate }}</h3>
                    <div class="status-line">
                        <span>{{ 'Pairing' | translate }}</span>
                        <strong *ngIf="!shouldUnpairBeVisible"
                                class="danger-text">{{ 'Ready to pair' | translate }}</strong>
                        <strong *ngIf="shouldUnpairBeVisible">{{ 'Paired' | translate }}</strong>
                    </div>
                    <button (click)="showUnpairDeviceDialog()" *ngIf="shouldUnpairBeVisible"
                            [disabled]="!canUnpairDevice"
                            [title]="(canUnpairDevice ? 'Unpair device' : 'The canunpairdevice permission is required') | translate"
                            class="btn btn-sm btn-info" type="button">{{ 'Unpair' | translate }}
                    </button>

                    <div class="status-line">
                        <span>Drink Safe</span>
                        <strong>{{ carDetails.Services.HasAccessToDrinkSafe }}</strong>
                    </div>
                    <button (click)="testNewBtn()" class="btn btn-sm btn-info" type="button">Drink Safe</button>

                    <div class="status-line">
                        <span>{{ 'Package' | translate }}</span>
                        <strong class="success-text">{{ carDetails.Services.Package }}
                            ({{ carDetails.CarPreferences.PricePerKm }})</strong>
                    </div>
                    <button (click)="selectPackage()" class="btn btn-sm btn-info"
                            type="button">{{ 'Select package' | translate }}
                    </button>
                </div>
            </section>

            <section class="detail-panel suspension-panel">
                <div>
                    <h3>{{ 'Suspension' | translate }}</h3>
                    <div class="status-line inline">
                        <span>{{ 'Status' | translate }}</span>
                        <strong *ngIf="!carDetails.Suspension.IsSuspended"
                                class="success-text">{{ 'No' | translate }}</strong>
                        <strong *ngIf="carDetails.Suspension.IsSuspended"
                                class="danger-text">{{ 'Yes' | translate }}</strong>
                    </div>
                    <div *ngIf="carDetails.Suspension.IsSuspended" class="suspension-meta">
                        <span>{{ 'Until' | translate }} {{ carDetails.Suspension.SuspensionUntilDate_iso | date: 'dd.MM.yyyy HH:mm' }}</span>
                        <span>{{ carDetails.Suspension.Reason }}</span>
                    </div>
                </div>
                <div class="button-row">
                    <button (click)="suspendCar()" class="btn btn-sm btn-danger"
                            type="button">{{ 'Suspend' | translate }}
                    </button>
                    <button (click)="unsuspendCar()" class="btn btn-sm btn-success"
                            type="button">{{ 'Unsuspend' | translate }}
                    </button>
                </div>
            </section>

            <section class="detail-panel">
                <h3>{{ 'Drivers' | translate }}</h3>
                <div class="drivers-grid">
                    <div *ngFor="let driver of carDetails.Drivers" class="driver-card">
                        <button (click)="onDriverSelected(driver.DriverIdentifier)" class="driver-select-button"
                                type="button">
                            <img class="img-fluid imgDriverSize"
                                 onerror="this.onerror=null;this.src='assets/images/no_image.png'"
                                 src="{{baseUrlForImages}}{{driver.DriverPicture}}">
                            <span class="driver-name">{{ driver.DriverName }}</span>
                        </button>
                        <div *ngIf="getDriverPhone(driver) !== ''" class="driver-phone-line">
                            <span>{{ getDriverPhone(driver) }}</span>
                            <a [href]="'tel:' + getDriverPhone(driver)" [title]="'Call driver' | translate"
                               class="call-button">
                                <i class="material-icons">phone</i>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</app-modal>

<div *ngIf="notificationMessage" [class]="'app-toast app-toast--' + notificationType" role="status">
    <i class="material-icons">add_alert</i>
    <span>{{ notificationMessage }}</span>
</div>

<ng-template #dialogsContainer2></ng-template>
